import { NgModule } from '@angular/core';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [BaseLayoutComponent, ConfirmationDialogComponent],
  imports: [AppRoutingModule, SharedModule],
  exports: [AppRoutingModule],
})
export class CoreModule {}
